import { render } from "./ConfermaCodiceDueFattori.vue?vue&type=template&id=7937231a&scoped=true"
import script from "./ConfermaCodiceDueFattori.vue?vue&type=script&lang=js"
export * from "./ConfermaCodiceDueFattori.vue?vue&type=script&lang=js"

import "./ConfermaCodiceDueFattori.vue?vue&type=style&index=0&id=7937231a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\adria\\OneDrive\\Escritorio\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7937231a"]])

export default __exports__